import { FC } from 'react';
import { Box, Button, Text } from '@mantine/core';
import styles from './AiCallingCard.module.css';

const AiCallingCard: FC = () => {
    return (
        <Box className="flex flex-col justify-center items-center">
            <Text className={styles.fadeText} fw={500} fz={17}>
                AI is calling you!
            </Text>
            <Text fw={600} fz={32}>
                Check Your phone!
            </Text>

            <img
                alt="phone"
                src="https://storage.googleapis.com/newo-static-files/static-images/ai-calling.svg"
            />

            <Button px={45}>
                <Text>Ok</Text>
            </Button>
        </Box>
    );
};

export default AiCallingCard;
